import moment from 'moment';

export default (() => {

    function getPaymentMethodLabel(method) {

        switch (method) {

            case 'card':
                return 'Card';

            case 'invoice':
                return 'Invoice';

            default:
                return null;
        }
    }

    function format(booking) {

        var formattedBooking = { ...booking };

        formattedBooking.created_at_label = moment(booking.created_at).format('DD.MM.YYYY');

        formattedBooking.payment_method_label = getPaymentMethodLabel(booking.payment_method);

        formattedBooking.total_charge = parseFloat(booking.total_charge).toFixed(2);
        formattedBooking.vat          = parseFloat(booking.vat).toFixed(2);
        formattedBooking.subtotal     = parseFloat(booking.subtotal).toFixed(2);

        return formattedBooking;
    }

    return {
        format
    };

})();


// WEBPACK FOOTER //
// ./services/bookingFormatter.js